<nb-card class="delete-dialog">
  <nb-card-header>
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    <span>تکرار منبع داده</span>
  </nb-card-header>
  <nb-card-body>
    <div>
      <div class="pb-2">
        آﯾﺎ از تکرار منبع داده “ {{datasourceName}} ” اﻃﻤﯿﻨﺎن دارﯾﺪ؟
      </div>
      <div class="info-container">
        <div
          class="info-header d-flex align-items-center justify-content-between"
          (click)="toggleInfo()"
        >
          <span>اطلاعات</span>
          <div class="d-flex align-items-center gap-1">
            <span class="toggle-text">{{
              isInfoExpanded ? "کمتر" : "بیشتر"
            }}</span>
            <morva-icons
              [icon]="isInfoExpanded ? 'caretUpOutline' : 'caretDownOutline'"
              class="icon-12 cursor-pointer"
            ></morva-icons>
          </div>
        </div>
        <div class="info-list" *ngIf="isInfoExpanded">
          <div *ngFor="let info of infoList" class="info-item">
            ● {{ info }}
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <div class="nb-card-footer">
    <button nbButton (click)="closeDialog()" class="cancle-button">
      انصراف
    </button>
    <button nbButton (click)="onSubmitClick()" class="submit-button" data-testid="submit-btn"
      nbSpinnerStatus="primary">
      تکرار
    </button>
  </div>
</nb-card>